import React, {useState} from "react";
import "./Level2Taquin.css";
import Button from "@mui/material/Button"; // Add CSS for styling

export const Level2Taquin = ({isCompleted, setCompleted, setBack}) => {

    const completedGrid = [
        {id: "a1", img: "/public/anniv/2025/lvl2_taquin_a1.png"},
        {id: "a2", img: "/public/anniv/2025/lvl2_taquin_a2.png"},
        {id: "a3", img: "/public/anniv/2025/lvl2_taquin_a3.png"},
        {id: "a4", img: "/public/anniv/2025/lvl2_taquin_a4.png"},
        {id: "b1", img: "/public/anniv/2025/lvl2_taquin_b1.png"},
        {id: "b2", img: "/public/anniv/2025/lvl2_taquin_b2.png"},
        {id: "b3", img: "/public/anniv/2025/lvl2_taquin_b3.png"},
        {id: "b4", img: "/public/anniv/2025/lvl2_taquin_b4.png"},
        {id: "c1", img: "/public/anniv/2025/lvl2_taquin_c1.png"},
        {id: "c2", img: "/public/anniv/2025/lvl2_taquin_c2.png"},
        {id: "c3", img: "/public/anniv/2025/lvl2_taquin_c3.png"},
        {id: "c4", img: "/public/anniv/2025/lvl2_taquin_c4.png"},
        {id: "d1", img: "/public/anniv/2025/lvl2_taquin_d1.png"},
        {id: "d2", img: "/public/anniv/2025/lvl2_taquin_d2.png"},
        {id: "d3", img: "/public/anniv/2025/lvl2_taquin_d3.png"},
        {id: "d4", img: null}, // Empty tile
    ];

    const initialGrid = [
        {id: "a2", img: "/public/anniv/2025/lvl2_taquin_a2.png"},
        {id: "a4", img: "/public/anniv/2025/lvl2_taquin_a4.png"},
        {id: "c1", img: "/public/anniv/2025/lvl2_taquin_c1.png"},
        {id: "b2", img: "/public/anniv/2025/lvl2_taquin_b2.png"},
        {id: "c3", img: "/public/anniv/2025/lvl2_taquin_c3.png"},
        {id: "a3", img: "/public/anniv/2025/lvl2_taquin_a3.png"},
        {id: "a1", img: "/public/anniv/2025/lvl2_taquin_a1.png"},
        {id: "d3", img: "/public/anniv/2025/lvl2_taquin_d3.png"},
        {id: "c2", img: "/public/anniv/2025/lvl2_taquin_c2.png"},
        {id: "b4", img: "/public/anniv/2025/lvl2_taquin_b4.png"},
        {id: "b1", img: "/public/anniv/2025/lvl2_taquin_b1.png"},
        {id: "c4", img: "/public/anniv/2025/lvl2_taquin_c4.png"},
        {id: "d2", img: "/public/anniv/2025/lvl2_taquin_d2.png"},
        {id: "b3", img: "/public/anniv/2025/lvl2_taquin_b3.png"},
        {id: "d1", img: "/public/anniv/2025/lvl2_taquin_d1.png"},
        {id: "d4", img: null}, // Empty tile
    ];

    const [grid, setGrid] = useState(isCompleted ? completedGrid : initialGrid);
    const [complete, setComplete] = useState(isCompleted);

    const handleTileClick = (index) => {
        if (complete) {
            return;
        }
        const emptyIndex = grid.findIndex((tile) => tile.img === null);
        const isAdjacent =
            Math.abs(emptyIndex - index) === 1 || Math.abs(emptyIndex - index) === 4;

        if (isAdjacent) {
            const newGrid = [...grid];
            [newGrid[emptyIndex], newGrid[index]] = [newGrid[index], newGrid[emptyIndex]];
            setGrid(newGrid);

            // Check if the grid is completed
            if (newGrid.every((tile, i) => tile.id === "abcd".charAt(Math.floor(i / 4)) + (i % 4 + 1))){
                setCompleted(true);
                setComplete(true);
            }
        }
    };

    return (
        <div className="taquin-canvas">
            <div className="taquin-grid">
                {grid.map((tile, index) => (
                    <div
                        key={tile.id}
                        className={`taquin-tile ${tile.img ? "" : (complete ? "empty-tile-completed" : "empty-tile")}`}
                        onClick={() => handleTileClick(index)}
                        style={{
                            backgroundImage: tile.img ? `url(${tile.img})` : "none",
                        }}
                    ></div>
                ))}
            </div>
            {
                complete ?
                <div>
                    <br/>
                    <br/>
                    <br/>
                Mais oui, c'est tout de suite plus clair !
                </div> : undefined
            }
            <div style={{textAlign: "center", marginTop: "3vh"}}>
                <Button variant="contained" type="submit" onClick={() => setBack()}>
                    Retour
                </Button>
            </div>
        </div>
    );
};
